module.exports = __webpack_public_path__ + "img/tns.94e444a1.jpg";